import { call, put, takeLatest } from 'redux-saga/effects';
import {
  DOWNLOAD_DISCOUNT_BLACKLIST,
  FETCH_DISCOUNT_SETTINGS,
  UPLOAD_DISCOUNT_BLACKLIST,
  UPDATE_DISCOUNT_SETTINGS,
  UPDATE_DISCOUNT_BOTTOM_PRICE,
  DOWNLOAD_DISCOUNT_SCHEME,
} from 'state/actionTypes';
import * as action from 'state/discountSettings/actions';
import * as toast from 'state/toast/actions';
import * as api from 'api/discountSettings/discountSettings';

export function* fetchDiscountSettings() {
  try {
    const response = yield call(api.getDiscountSettings);
    yield put(
      action.setFetchDiscountSettings(
        response.data.data.sort((a, b) => a.key.localeCompare(b.key))
      )
    );
  } catch (error) {
    yield put(
      toast.errorMessage('Get discount settings failed', error.message)
    );
  }
}

export function* updateDiscountSettings({ payload }) {
  try {
    yield put(action.setUpdateDiscountSettings(true));
    const file = payload.values.discountSchemes[0];

    const response = yield call(api.putDiscountSettings, file);
    yield put(toast.successMessage(`Successfully updated discount settings!`));
    yield put(
      action.setFetchDiscountSettings(
        response.data.data.sort((a, b) => a.key.localeCompare(b.key))
      )
    );
  } catch (error) {
    yield put(
      toast.errorMessage('Update discount settings failed', error.message)
    );
  } finally {
    yield put(action.setUpdateDiscountSettings(false));
  }
}

export function* updateDiscountBottomPrice({ payload }) {
  try {
    yield put(action.setUpdateDiscountBottomPrice(true));
    const response = yield call(
      api.putDiscountBottomPrice,
      payload.bottomPrice,
      payload.bottomPriceType
    );
    yield put(
      toast.successMessage(`Successfully updated discount bottom price!`)
    );
    yield put(
      action.setFetchDiscountSettings(
        response.data.data.sort((a, b) => a.key.localeCompare(b.key))
      )
    );
  } catch (error) {
    yield put(
      toast.errorMessage('Update discount bottom price failed', error.message)
    );
  } finally {
    yield put(action.setUpdateDiscountBottomPrice(false));
  }
}

export function* uploadDiscountBlacklist({ payload }) {
  try {
    yield put(action.setUploadingDiscountBlacklist(true));
    const file = payload.values.blacklist[0];

    yield call(api.putDiscountBlacklist, file);
    yield put(toast.successMessage(`Successfully updated discount blacklist!`));
  } catch (error) {
    yield put(
      toast.errorMessage('Update discount blacklist failed', error.message)
    );
  } finally {
    yield put(action.setUploadingDiscountBlacklist(false));
  }
}

export function* downloadDiscountBlacklist() {
  try {
    yield put(action.setDownloadingDiscountBlacklist(true));
    const response = yield call(api.getDiscountBlacklist);
    const csvData = new Blob([response.data], { type: 'text/csv' });
    const downloadUrl = URL.createObjectURL(csvData);

    // Create an anchor element and programmatically trigger the download
    const downloadLink = document.createElement('a');
    downloadLink.href = downloadUrl;
    downloadLink.download = 'blacklist.csv'; // Set the desired file name and extension
    downloadLink.click();

    // Clean up the URL created for the blob
    URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    yield put(
      toast.errorMessage('Download discount blacklist failed', error.message)
    );
  } finally {
    yield put(action.setDownloadingDiscountBlacklist(false));
  }
}

export function* downloadDiscountScheme({ payload }) {
  const { discountSettings } = payload;

  const discountScheme = discountSettings.slice(2); // the first 2 are bottom price data, so we remove it

  const rows = [['Timeline (DO NOT EDIT)', 'Discount']];

  // generate CSV
  discountScheme.forEach(scheme => {
    rows.push([scheme.key, scheme.value]);
  });

  let csvContent = 'data:text/csv;charset=utf-8,';

  rows.forEach(rowArray => {
    const row = rowArray.join(',');
    csvContent += `${row}\r\n`;
  });

  try {
    // downloading
    const encodedUri = encodeURI(csvContent);
    const downloadLink = document.createElement('a');
    downloadLink.href = encodedUri;
    downloadLink.download = 'discount_scheme.csv'; // Set the desired file name and extension
    downloadLink.click();
  } catch (error) {
    yield put(
      toast.errorMessage('Download discount scheme failed', error.message)
    );
  }
}

export default function* saga() {
  yield takeLatest(FETCH_DISCOUNT_SETTINGS, fetchDiscountSettings);
  yield takeLatest(UPDATE_DISCOUNT_BOTTOM_PRICE, updateDiscountBottomPrice);
  yield takeLatest(UPDATE_DISCOUNT_SETTINGS, updateDiscountSettings);
  yield takeLatest(UPLOAD_DISCOUNT_BLACKLIST, uploadDiscountBlacklist);
  yield takeLatest(DOWNLOAD_DISCOUNT_BLACKLIST, downloadDiscountBlacklist);
  yield takeLatest(DOWNLOAD_DISCOUNT_SCHEME, downloadDiscountScheme);
}
